import * as React from "react"
import { createIcon } from "@chakra-ui/react"

export const HighlightDarkIcon = createIcon({
  displayName: "HighlightDarkIcon",
  viewBox: "0 0 280 28",
  defaultProps: {
    width: "280px",
    height: "28px",
  },
  path: (
    <path
      fill="#4f4f4f"
      fillRule="evenodd"
      d="m20.6346731 83.9663075c86.1260839-6.1137391 172.4203649-7.4610588 258.6925159-4.0331241 14.24369.5654325 14.217133-21.5217751 0-22.0872076-86.272151-3.4279347-172.566432-2.080615-258.6925159 4.0331241-14.12418197 1.0027592-14.23483837 23.0988017 0 22.0872076"
      transform="translate(-10 -56)"
    />
  ),
})
